import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PhioStore } from '../../../../redux/types';

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const location = useLocation();

    const auth = useSelector((state: PhioStore) => state.phioReducer.auth);

    const isAuth = auth != null;

    if (!isAuth) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default PrivateRoute;
